import type { Unit } from "../models/Unit";
import { CreateCrudService } from "./CrudServiceFactory";
import { apiClient } from "../api/ApiClient";
import { BuildFormData } from "../utils/Util";
export function UnitService() {
  return CreateCrudService<Unit>({
    Route: "unit",
    EntityName: "Unit",
    PaginationInPath: true,
    PartialFields: ["Code", "Name", "IsActive"],
    LoadingMessage: "Loading units…",
    SavingMessage: "Saving unit…",
    DeleteAction: "DeleteUnit",
    SaveRequest: async (data) =>
      (await apiClient.post<Unit[]>("unit/SaveUnit", data)).data,
  });
}
